export default "__VITE_ASSET__Bsi32YNP__"